<script>
    import { tweened } from 'svelte/motion';
    import { cubicOut } from 'svelte/easing';  
    import { afterUpdate, onMount } from 'svelte'; 

    export let percent = 0;
    export let fromPercent = 0;

    let progress;
    
    onMount(() => {
        progress = tweened(fromPercent, {
            duration: 700,
            easing: cubicOut,
        });
    });

    afterUpdate(() => {
        progress.set(percent);
    });
</script>

<div class="progress-bar-container">
    <div class="progress-bar" style="width: {$progress || 0}%;">&nbsp;</div>
</div>
